import { Actions } from "./actions";
import { CloseIcon } from "../../../assets";
import { Content } from "./content";
import { Dialog } from "@material-ui/core";
import { Title } from "./title";
import React, { Fragment } from "react";

type ModalProps = {
  title?: React.ReactNode;
  content?: React.ReactNode;
  actions?: React.ReactNode;
  open: boolean;
  classNames?: Partial<{
    paper: string;
    container: string;
    title: string;
    content: string;
    actions: string;
  }>;
  onClose: () => void;
};

export const Modal = ({
  title,
  content,
  actions,
  open,
  classNames,
  onClose,
}: ModalProps): React.ReactElement => (
  <Dialog
    aria-labelledby="customized-dialog"
    open={open}
    onClose={onClose}
    className={classNames?.container}
    classes={{
      paper: classNames?.paper,
    }}
  >
    <Fragment>
      <button
        className="absolute top-[16px] right-[16px] z-[1000] cursor-pointer"
        onClick={() => onClose()}
      >
        <CloseIcon />
      </button>
      {title ? (
        <Title className={classNames?.title} onClose={onClose}>
          {title}
        </Title>
      ) : null}
      {content ? (
        <Content className={classNames?.content}>{content}</Content>
      ) : null}
      {actions ? (
        <Actions className={classNames?.actions}>{actions}</Actions>
      ) : null}
    </Fragment>
  </Dialog>
);
